import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LoaderContext } from "../../../../../Services/Loader_Provider_Service/LoadingContext";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { addModule, AddQuestionOptions, getOnlineTraining } from "../../Services/SelfLearning";
import { useFormik } from "formik";
import * as Yup from 'yup'
import { GetMasterTypeData } from "../../../../../Services/Global-Services/GlobalServices";
import { Dropdown } from "primereact/dropdown";
import ERROR_LIST from "../../../../../Services/Global-Services/Hadle_Errors";
import { TostMsg } from "../../../../../App";

function AddQuizQuestion() {
    let userDetails = JSON.parse(localStorage.getItem("User") || '{}');
  const [quizQuestion, setQuizQuestion] = useState([]);
    const [courses, setCourses] = useState([]);
    const { showLoading, hideLoading } = useContext(LoaderContext);
    const { CourseId } = useParams();
    let navigateTo = useHistory();
  const toster = useContext(TostMsg);

    useEffect(() => {
        GetOnlineTraining();
        getQuizQuestion();
    }, []);

    async function GetOnlineTraining() {
        showLoading();
        let body = {
            "AccountId": userDetails?.OrgId,
            "LoggedInUserId": userDetails?.EmpId,
            "UserId": 0,
            "CourseId": Number(CourseId),
            "Search": "",
            "PageNumber": 1,
            "CategoryId": 0,
            "PageSize": 100,
            "NewOnly": 0,
            "BookmarkedOnly": 0,
            "FreeOnly": 0,
            "MyCourse": 0
        }
        try {
            let response = await getOnlineTraining(body);
            hideLoading();
            setCourses(response.Data.courses[0]);
        } catch (err) {
            hideLoading();
        }
    }

    const quizValidation = Yup.object().shape({
        questions: Yup.array().of(
            Yup.object().shape({
                QuestionText: Yup.string().required('Question is required.'),
                QuestionType: Yup.string().required('Question type is required.'),
                options: Yup.array().of(
                    Yup.string().required('Option is required.')
                ),
                IsCorrectId: Yup.number().nullable().required('Correct option is required.')
            })
        )
    });

    const quizForm = useFormik({
        initialValues: {
            questions: [
                {
                    QuestionText: '',
                    QuestionType: '',
                    options: ['', '', '', ''],
                    IsCorrectId: null
                }
            ]
           
        },
        validationSchema: quizValidation,
        onSubmit: async (data) => {
            showLoading();
            let params = data.questions.map(question => ({
                ...question,
                AnsTypeId: 0,
                "Id": 0,
                "GUID": userDetails.GUID,
                "IsActive": true,
                "CreatedDate": "2024-08-06T12:27:53.158Z",
                "ModifiedDate": "2024-08-06T12:27:53.158Z",
                "CreatedBy": Number(userDetails.EmpId),
                "ModifiedBy": Number(userDetails.EmpId),
                "OrgId": Number(userDetails.OrgId),
                QUIZid: 0,
                CourseId: Number(CourseId),
                ModuleId: 0,
                InputtypeId: 0,
                lstQuestionOptions: question.options.map((option, index) => ({
                    "Id": 0,
                    "GUID": userDetails.GUID,
                    "IsActive": true,
                    "CreatedDate": "2024-08-06T12:27:53.158Z",
                    "ModifiedDate": "2024-08-06T12:27:53.158Z",
                    "OrgId": Number(userDetails.OrgId),
                    "Empid": Number(userDetails.EmpId),
                    "CreatedBy": Number(userDetails.EmpId),
                    "ModifiedBy": Number(userDetails.EmpId),
                    "QuestionId": 0,
                    "Options": option,
                    "IsCorrectId": question.IsCorrectId === index,
                    "Moduleid": 0,
                    "QuizId": 0,
                    "CourseId": Number(CourseId),
                    "LessonId": 0,
                    "Answerid": 0
                }))
            }));
            try {await AddQuestionOptions(params[0]);
                // navigateTo.push(`/SelfLearningDashboard/CourseDetails/${CourseId}`);
                hideLoading();
            } catch (err) {
                hideLoading();
            }
        }
    });


     const getQuizQuestion = async () => {
        let params = {
          masterType: "QuizQuestion",
          allRecords: true,
          organisationId: userDetails?.OrgId,
        };
        try {
          let responce = await GetMasterTypeData(params);
          setQuizQuestion(responce?.Data);
        } catch (error) {
          toster.current.error(ERROR_LIST?.MasterDataType);
        }
       
      };

    const addQuestion = () => {
        quizForm.setFieldValue('questions', [
            ...quizForm.values.questions,
            { QuestionText: '', QuestionType:'', options: ['', '', '', ''], IsCorrectId: null }
        ]);
    };

    const deleteQuestion = (index) => {
        quizForm.setFieldValue('questions', quizForm.values.questions.filter((_, i) => i !== index));
    };

    const addOption = (questionIndex) => {
        const newOptions = [...quizForm.values.questions[questionIndex].options, ''];
        quizForm.setFieldValue(`questions.${questionIndex}.options`, newOptions);
    };

    const removeLastOption = (questionIndex) => {
        const newOptions = quizForm.values.questions[questionIndex].options.slice(0, -1);
        quizForm.setFieldValue(`questions.${questionIndex}.options`, newOptions);
    };

    return (
        <div>
            {/* <!-- row --> */}
            <div className="container-fluid">
                <div className="col-md-8 shrink-w">
                    <div className="form-head d-flex flex-wrap align-items-center mb-3">
                        <div className="me-auto">
                            <h2 className="font-w600 mb-0">Add Quizzes</h2>
                            <p className="text-light">Lorem ipsum dolor sit amet</p>
                        </div>
                        <div className="rightside-tabs">
                            <Link to={`/SelfLearningDashboard/CourseDetails/${CourseId}`}><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-arrow-left-short" viewBox="0 0 16 16"><path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"></path></svg></Link>
                        </div>
                    </div>
                    <form onSubmit={quizForm.handleSubmit}>
                        {quizForm.values.questions.map((question, qIndex) => (
                            <div key={qIndex} className="row mb-4">
                                <div className="mb-4 col-md-12">
                                    <label className="form-label">Question</label>
                                    <textarea
                                        name={`questions.${qIndex}.QuestionText`}
                                        className={"form-control" + (quizForm.errors.questions?.[qIndex]?.QuestionText && quizForm.touched.questions?.[qIndex]?.QuestionText ? ' is-invalid' : '')}
                                        rows="10"
                                        value={question.QuestionText}
                                        onChange={quizForm.handleChange}
                                    />
                                    {quizForm.errors.questions?.[qIndex]?.QuestionText && quizForm.touched.questions?.[qIndex]?.QuestionText ? (
                                        <div className="invalid-feedback">{quizForm.errors.questions[qIndex].QuestionText}</div>
                                    ) : null}
                                </div>
                                <div className="mb-4 col-md-4">
                                    <label className="form-label">Question Type</label>
                                    <Dropdown name={`questions.${qIndex}.QuestionType`}
                                        value={question.QuestionType}
                                        onChange={(e) => quizForm.setFieldValue(`questions.${qIndex}.QuestionType`, e.value.Name)}
                                        onBlur={quizForm.handleBlur} options={quizQuestion} optionLabel="Name"
                                        placeholder="Select a type" checkmark={true} highlightOnSelect={false} />
                                    {quizForm.errors.questions?.[qIndex]?.QuestionType && quizForm.touched.questions?.[qIndex]?.QuestionType ? (
                                        <div className="invalid-feedback">{quizForm.errors.questions[qIndex].QuestionType}</div>
                                    ) : null}
                                </div>
                                {question.options.map((option, oIndex) => (
                                    <div key={oIndex} className="mb-4 col-md-12">
                                        <label className="form-label">{`Option ${String.fromCharCode(65 + oIndex)}`}</label>
                                        <div className="check-answer">
                                            <div className="input-group">
                                                <input
                                                    name={`questions.${qIndex}.options.${oIndex}`}
                                                    className={"form-control" + (quizForm.errors.questions?.[qIndex]?.options?.[oIndex] && quizForm.touched.questions?.[qIndex]?.options?.[oIndex] ? ' is-invalid' : '')}
                                                    value={option}
                                                    onChange={quizForm.handleChange}
                                                />
                                                <div className="input-group-append">
                                                    <div className="input-group-text">
                                                        <input
                                                            type="radio"
                                                            name={`questions.${qIndex}.IsCorrectId`}
                                                            checked={quizForm.values.questions[qIndex].IsCorrectId === oIndex}
                                                            onChange={() => quizForm.setFieldValue(`questions.${qIndex}.IsCorrectId`, oIndex)}
                                                        />
                                                    </div>
                                                </div>
                                                {quizForm.errors.questions?.[qIndex]?.options?.[oIndex] && quizForm.touched.questions?.[qIndex]?.options?.[oIndex] ? (
                                                    <div className="invalid-feedback">{quizForm.errors.questions[qIndex].options[oIndex]}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="mb-4 col-md-6">
                                    <button type="button" onClick={() => addOption(qIndex)} className="btn btn-secondary btn-rounded">Add Option</button>
                                </div>
                                <div className="mb-4 col-md-6">
                                    {question.options.length > 2 && (
                                        <button type="button" onClick={() => removeLastOption(qIndex)} className="btn btn-secondary btn-rounded">Remove Option</button>
                                    )}
                                </div>
                                <div className="mb-4 col-md-6">
                                    <button type="button" onClick={() => deleteQuestion(qIndex)} className="btn btn-secondary btn-rounded">Delete Question</button>
                                </div>
                            </div>
                        ))}
                        <div className="col-md-6">
                            <button type="button" onClick={addQuestion} className="btn btn-primary btn-rounded">Add Question</button>
                        </div>
                        <div className="col-md-6">
                            <button type="submit" className="btn btn-primary btn-rounded">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddQuizQuestion;